var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mdc-textfield-container card-title-input" },
    [
      _c(
        "div",
        { staticClass: "mdc-textfield", class: _vm.inputValidationBindings },
        [
          _c("input", {
            staticClass: "mdc-textfield__input",
            attrs: {
              type: "text",
              id: "card-title-input",
              required: "",
              placeholder: _vm.$t("card_details.card_meta.title_placeholder")
            },
            domProps: { value: _vm.text },
            on: { input: _vm.onInput }
          })
        ]
      ),
      _vm._v(" "),
      _vm.errors.has("text:required")
        ? _c(
            "p",
            {
              staticClass:
                "mdc-textfield-helptext mdc-textfield-helptext--persistent mdc-textfield-helptext--validation-msg",
              attrs: { role: "alert" }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("card_details.error.title_required")) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.has("text:max")
        ? _c(
            "p",
            {
              staticClass:
                "mdc-textfield-helptext mdc-textfield-helptext--persistent mdc-textfield-helptext--validation-msg",
              attrs: { role: "alert" }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("card_details.error.title_max_len")) +
                  "\n  "
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0817bcb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0817bcb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardTitleInput.vue
// module id = QKZm
// module chunks = 1